import { render, staticRenderFns } from "./CodeRedeem.vue?vue&type=template&id=1c316b99&"
import script from "./CodeRedeem.vue?vue&type=script&lang=js&"
export * from "./CodeRedeem.vue?vue&type=script&lang=js&"
import style0 from "./CodeRedeem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c316b99')) {
      api.createRecord('1c316b99', component.options)
    } else {
      api.reload('1c316b99', component.options)
    }
    module.hot.accept("./CodeRedeem.vue?vue&type=template&id=1c316b99&", function () {
      api.rerender('1c316b99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CodeRedeem.vue"
export default component.exports